import { render, staticRenderFns } from "./ClamMstPopupTableInfo1.vue?vue&type=template&id=63fa1677&"
import script from "./ClamMstPopupTableInfo1.vue?vue&type=script&lang=js&"
export * from "./ClamMstPopupTableInfo1.vue?vue&type=script&lang=js&"
import style0 from "./ClamMstPopupTableInfo1.vue?vue&type=style&index=0&id=63fa1677&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports